/**
 * Markdown in den Neuigkeiten — die zwei Umformungen, die die Ansicht davor braucht.
 *
 * Geschrieben wird in zwei schlichte Textfelder, und wer dort gliedern will, schreibt
 * Markdown; der erste laengere Eintrag auf dem Produktivsystem tat genau das. Angezeigt
 * wurde er als eine Wurst mit Sternchen darin.
 */

/**
 * Macht aus einem einzelnen Zeilenumbruch einen echten Umbruch.
 *
 * In Markdown trennt erst eine Leerzeile zwei Absaetze; ein einzelner Umbruch gilt als
 * Fortsetzung derselben Zeile. Die Eintraege von vor dieser Aenderung sind aber reiner
 * Text, in dem jeder Umbruch zaehlt - ohne diese Zeile zoege das Rendern sie zusammen,
 * und eine alte Neuigkeit saehe nach dem Update schlechter aus als vorher.
 *
 * Zwei Leerzeichen am Zeilenende sind in Markdown der harte Umbruch.
 */
export const mitHartenUmbruechen = (text: string): string =>
  text.replace(/([^\n])\n(?!\n)/g, "$1  \n");

/**
 * Wirft die Markdown-Zeichen weg und laesst den Text stehen.
 *
 * Fuer die Liste im Neuigkeiten-Bereich: Dort stehen zwei Zeilen Vorschau, und in denen
 * soll weder "### " noch "**" auftauchen. Gerendertes Markdown waere dort falsch - eine
 * Ueberschrift in einer abgeschnittenen Vorschauzeile ist keine Ueberschrift mehr.
 */
export const alsReinerText = (markdown: string): string =>
  markdown
    // Bilder ganz raus, Links auf ihre Beschriftung eindampfen.
    .replace(/!\[[^\]]*\]\([^)]*\)/g, "")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    // Ueberschriften, Zitate und Listenzeichen am Zeilenanfang.
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/^\s{0,3}>\s?/gm, "")
    .replace(/^\s{0,3}[-*+]\s+/gm, "")
    .replace(/^\s{0,3}\d+\.\s+/gm, "")
    // Trennlinien.
    .replace(/^\s{0,3}([-*_])\s*(\1\s*){2,}$/gm, "")
    // Auszeichnungen im Fliesstext.
    .replace(/(\*\*|__)(.*?)\1/g, "$2")
    .replace(/(\*|_)(.*?)\1/g, "$2")
    .replace(/~~(.*?)~~/g, "$1")
    .replace(/`([^`]*)`/g, "$1")
    // Alles auf eine Zeile: Die Vorschau ist zwei Zeilen hoch und schneidet selbst ab.
    .replace(/\s+/g, " ")
    .trim();
